/* Inject product tabs into Quick Shop modal by fetching the section HTML for the product */
(function () {
  var MODAL_CONTENT_SELECTOR = '[data-modal-content]';
  var STATIC_PRODUCT_SELECTOR = '[data-section-type="static-product"]';
  var TABS_SECTION_ID = 'product-tabs';
  var TABS_ROOT_CLASS = 'kg-product-tab';
  var PRODUCT_WRAPPER_SELECTOR = '[data-product-wrapper]';

  function getModalContentEl() {
    return document.querySelector(MODAL_CONTENT_SELECTOR);
  }

  function parseProductSettings(modalEl) {
    var scriptEl = modalEl && modalEl.querySelector(STATIC_PRODUCT_SELECTOR);
    if (!scriptEl) return null;
    try {
      return JSON.parse(scriptEl.textContent || scriptEl.innerHTML || '{}');
    } catch (e) {
      return null;
    }
  }

  function appendTabsIfMissing(modalEl, tabsHtml) {
    if (!modalEl || !tabsHtml) return;
    if (modalEl.querySelector('.' + TABS_ROOT_CLASS)) return; // already present

    var container = document.createElement('div');
    container.innerHTML = tabsHtml;

    // Prefer the section wrapper id if present; else the tabs root
    var sectionEl = container.querySelector('#shopify-section-' + TABS_SECTION_ID) || container.querySelector('.' + TABS_ROOT_CLASS);
    if (!sectionEl) return;

    // Choose a visible target inside the quickshop, defaulting to the modal content
    var target = modalEl.querySelector('[data-product-details]') || modalEl;
    target.appendChild(sectionEl);

    // Initialize tab interactions since inline scripts in injected HTML won't run
    initTabs(sectionEl);
  }

  function initTabs(scopeEl) {
    try {
      var tabs = scopeEl.querySelectorAll('.product-tabs-wrapper .tab-item');
      var panels = scopeEl.querySelectorAll('.product-tabs-wrapper .tab-panel');
      if (!tabs.length || !panels.length) return;
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) { t.classList.remove('is-active'); });
          panels.forEach(function (p) { p.classList.remove('is-active'); });
          tab.classList.add('is-active');
          var target = tab.getAttribute('data-tab');
          var panel = scopeEl.querySelector('#' + CSS.escape(target));
          if (panel) panel.classList.add('is-active');
        });
      });
    } catch (e) {
      // no-op
    }
  }

  function fetchAndInjectTabs(modalEl, handle) {
    if (!handle) return;
    var url = '/products/' + encodeURIComponent(handle) + '?section_id=' + encodeURIComponent(TABS_SECTION_ID);
    fetch(url)
      .then(function (res) { return res.ok ? res.text() : null; })
      .then(function (html) { appendTabsIfMissing(modalEl, html); })
      .catch(function () { /* ignore */ });
  }

  function onModalUpdated() {
    var modalEl = getModalContentEl();
    if (!modalEl) return;

    // Wait for product wrapper to be present
    if (!modalEl.querySelector(PRODUCT_WRAPPER_SELECTOR)) return;

    var settings = parseProductSettings(modalEl);
    var handle = settings && settings.product && settings.product.handle;
    fetchAndInjectTabs(modalEl, handle);
  }

  function findModalContentFrom(node) {
    if (!node || node.nodeType !== 1) return null;
    return node.closest(MODAL_CONTENT_SELECTOR) || getModalContentEl();
  }

  function handlePossibleQuickshopNode(node) {
    if (!node || node.nodeType !== 1) return;
    var hasProductWrapper = node.matches && node.matches(PRODUCT_WRAPPER_SELECTOR) || (node.querySelector && node.querySelector(PRODUCT_WRAPPER_SELECTOR));
    if (!hasProductWrapper) return;
    var modalEl = findModalContentFrom(node);
    if (!modalEl) return;
    var settings = parseProductSettings(modalEl);
    var handle = settings && settings.product && settings.product.handle;
    fetchAndInjectTabs(modalEl, handle);
  }

  // Observe the modal content for changes (when quickshop content is inserted)
  var modalObserver = new MutationObserver(function () { onModalUpdated(); });
  // Fallback: observe the whole body for quickshop insertions
  var bodyObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes && m.addedNodes.forEach(function (n) { handlePossibleQuickshopNode(n); });
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    var modalContent = getModalContentEl();
    if (modalContent) {
      modalObserver.observe(modalContent, { childList: true, subtree: true });
    }
    if (document.body) {
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    }
    // Also run once in case modal already has content
    onModalUpdated();
  });
})();


